import { getPrePackSize } from "@faire/deprecated-retailer-visitor-shared/features/PrePacks/getPrePackSize";
import { isPrePackProductOption } from "@faire/deprecated-retailer-visitor-shared/features/PrePacks/isPrePackProduct";
import { getProductOptionProperty } from "@faire/deprecated-retailer-visitor-shared/lib/product";
import { ProductDetails } from "@faire/deprecated-retailer-visitor-shared/views/product/ProductDetails/model";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import { IProductOption } from "@faire/web-api--source/indigofair/data/IProductOption";
import {
  DEPRECATED_backwardsCompatibleValues,
  StrictLocalizeFunction,
} from "@faire/web/common/localization/localize";

export const buildCaseQuantityText = (
  product: Pick<
    ProductDetails.IProduct,
    "per_style_min_order_quantity" | "options" | "unit_multiplier"
  >,
  selectedOption:
    | Pick<IProductOption, "state" | "sizing_quantity" | "type">
    | undefined,
  strictLocalize: StrictLocalizeFunction
) => {
  if (selectedOption && isPrePackProductOption(selectedOption)) {
    const prePackUnitCount = getPrePackSize(selectedOption.sizing_quantity);

    if (prePackUnitCount > 0) {
      return strictLocalize(
        {
          id: "5HY+W+",
          defaultMessage: "{prePackUnitCount} per prepack",
          description: {
            text: "number of products per prepack",
          },
        },
        DEPRECATED_backwardsCompatibleValues({
          prePackUnitCount: prePackUnitCount,
        })
      );
    } else {
      return strictLocalize({
        id: "eFLRMH",
        defaultMessage: "(Unavailable)",
        description: { text: "Product is not available" },
      });
    }
  }

  if (selectedOption?.state !== IProduct.State.FOR_SALE) {
    return strictLocalize({
      id: "eFLRMH",
      defaultMessage: "(Unavailable)",
      description: { text: "Product is not available" },
    });
  }

  if (product.per_style_min_order_quantity) {
    return strictLocalize(
      {
        id: "PdjQCb",
        defaultMessage: "Min Qty {quantity}",
        description: {
          text: "minimum quantity to purchase the product",
        },
      },
      DEPRECATED_backwardsCompatibleValues({
        quantity: product.per_style_min_order_quantity,
      })
    );
  }

  return strictLocalize(
    {
      id: "t3bm6T",
      defaultMessage: "Case of {numCase}",
      description: {
        text: "Number of products per package",
      },
    },
    DEPRECATED_backwardsCompatibleValues({
      numCase: getProductOptionProperty(product, "unit_multiplier") || 1,
    })
  );
};
